<template>
  <div class="container_PFormRadioButton">
    <div class="label_PFormRadioButton" v-if="label != ''">{{ label }}</div>
    <span v-if="readonly && value">
      {{ textTrue }}
    </span>
    <span v-if="readonly && !value">
      {{ textFalse }}
    </span>
    <div class="radioButton_PFormRadioButton" v-if="!readonly">
      <div :class="classTrue" @click="ClickTrue">{{ textTrue }}</div>
      <div :class="classFalse" @click="ClickFalse">{{ textFalse }}</div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export class PFormRadioButton extends Vue {
  @Prop({ required: true }) value!: any;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = this.value;
  }
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: "Si" }) textTrue!: string;
  @Prop({ required: false, default: "No" }) textFalse!: string;
  @Prop({ required: false, default: true }) valueTrue!: any;
  @Prop({ required: false, default: false }) valueFalse!: any;
  @Prop({ required: false, default: false }) readonly!: any;
  valueLocal = "";
  get classTrue(): string {
    if (this.valueLocal === this.valueTrue) {
      return "trueSelected_PFormRadioButton";
    } else {
      return "true_PFormRadioButton";
    }
  }
  get classFalse(): string {
    if (this.valueLocal === this.valueFalse) {
      return "falseSelected_PFormRadioButton";
    } else {
      return "false_PFormRadioButton";
    }
  }
  ClickTrue(): void {
    this.valueLocal = this.valueTrue;
    this.$emit("input", this.valueLocal);
  }
  ClickFalse(): void {
    this.valueLocal = this.valueFalse;
    this.$emit("input", this.valueLocal);
  }
}
export default PFormRadioButton;
</script>
<style scoped>
.radioButton_PFormRadioButton {
  display: flex;
  justify-content: center;
}

.falseSelected_PFormRadioButton,
.trueSelected_PFormRadioButton,
.false_PFormRadioButton,
.true_PFormRadioButton {
  cursor: pointer;
  padding: 0.3rem;
  min-width: 40px;
  text-align: center;
  color: rgb(76, 76, 76, 0.7);
  border: 1px solid var(--amarillo-prosegur);
}
.falseSelected_PFormRadioButton,
.trueSelected_PFormRadioButton {
  background-color: var(--amarillo-prosegur);
  font-weight: bold;
  color: rgb(76, 76, 76);
}

.trueSelected_PFormRadioButton,
.true_PFormRadioButton {
  border-radius: 6px 0 0 6px;
}
.falseSelected_PFormRadioButton,
.false_PFormRadioButton {
  border-radius: 0 6px 6px 0;
}

.label_PFormRadioButton {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
}
</style>
